<template>
  <div class="App-news bg-white">
    <div class="inner text-left" v-show="!loading">
      <h1 class="h1">{{ nwList.title ? nwList.title.rendered :'' }}</h1>
      <div class="date-detail">{{ (nwList ? nwList.date :'') | moment('YYYY/MM/DD') }}</div>
      <div class="content detail">
        <div class="text white-space-pre-wrap" v-html="nwList.content ? nwList.content.rendered :''"></div>
      </div>
      <div class="btn-wrapper">
        <button class="btn btn-black text-white d-block position-relative" @click="goback" type="submit">{{$t('btn.back')}}</button>
      </div>
    </div>
    <div class="text-center mt-2 loading_icon" v-show="loading">
      <vue-loading type="spin" color="#DB1016" :size="{ width: '50px', height: '50px' }"></vue-loading>
    </div>
  </div>
</template>

<script>
  import { mapState, mapGetters, mapActions } from 'vuex'
  import { VueLoading } from 'vue-loading-template'
  import { META_NEWS } from '../../mixins/metadata.js'

  export default {
    mixins: [META_NEWS],
    name: 'NewsDetailPage',
    data() {
      return {
        nwList: [],
      }
    },
    components: {
      VueLoading,
    },
    methods: {
      ...mapActions('news', ['getNewsDetail', 'getNewsAll']),
      isSameCurrentDay(date) {
        return moment(date).isSame(moment(), 'day')
      },
      goback() {
        this.$router.go(-1)
      }
    },
    watch: {
      newsAll(data) {
        const questionAnswers = _.cloneDeep(data)
        const map = _.map(questionAnswers)
        const flatten = _.flattenDeep(map)
        const num = (this.$route.params.id) * 1
        const find = _.find(flatten, { id: num })
        this.$set(this, 'nwList', find)
      },
    },
    computed: {
      ...mapState('news', ['detail']),
      ...mapGetters('news', ['loading', 'newsAll']),
      newsId() {
        return this.$route.params.id
      },
    },
    created() {
      this.getNewsDetail(this.newsId)
      this.getNewsAll()
    },
  }
</script>
<style lang="scss">
.loading_icon{
  padding-top: 200px;
}
@media screen and (min-width:480px) {
  .loading_icon{
    padding-top: 100px;
  }
}
</style>
